module.exports = __webpack_public_path__ + "img/rarity-tools.e6f020a8.png";